export default class TextField {
  element: HTMLInputElement;
  methods;

  constructor(element: HTMLInputElement, methods:any) {
    if (element) {
      this.element = element;
      this.methods = methods;
      this.element.addEventListener('keyup', this.onUpdate, false);
      this.element.addEventListener('search', this.methods.resetAll, false);
    }
  }

  onUpdate = (event:Event) => {
    this.methods.onFilterChanged((event.target as HTMLInputElement).value, 'query');
  };
}
